export default __webpack_public_path__ + "static/media/logo-09-falkensteiner-hotels.8268de58.png";